import {
  itemWithNestingCanDrag,
  itemWithNestingBeginDrag,
  itemWithNestingEndDrag,
  itemWithNestingIsDragging,
  itemWithNestingDrop,
  itemWithNestingHover,
  itemWithNestingCanDrop,
} from 'Shared/utils/DnDSpecs/itemWithNestingDnDSpecs';
import { dragCollect, dropCollect } from 'Shared/utils/DnDSpecs/defaultDnDSpecs';

export const dragSpec = ({ uuid, forbidDrag, onDrop, onNestByDrag, dispatch, selector }) => ({
  canDrag: () => itemWithNestingCanDrag(forbidDrag),
  begin: () => itemWithNestingBeginDrag({ uuid, getState: () => dispatch((_, getState) => getState()), selector }),
  end: (item, monitor) => itemWithNestingEndDrag({ onDrop, onNestByDrag, dispatch }, monitor, item),
  isDragging: monitor => itemWithNestingIsDragging({ uuid }, monitor),
  collect: monitor => dragCollect(monitor),
});

export const dropSpec = ({ uuid, containerRef, todoData, setHoverOffset, setIsDropAsChild }) => ({
  hover: (item, monitor) =>
    itemWithNestingHover(
      { containerRef, parentUuid: todoData.parentUuid, setHoverOffset, setIsDropAsChild },
      monitor,
      item
    ),
  canDrop: item => itemWithNestingCanDrop({ uuid, parentUuid: todoData.parentUuid, itemType: todoData.itemType }, item),
  drop: (_, monitor) => itemWithNestingDrop({ uuid, id: todoData.id }, monitor),
  collect: monitor => dropCollect(monitor),
});
